import pub from './../public';
const type = pub.getLang();

const language = {
  'zh-hk': {
    confirmBtn: '確認',
    cancelBtn: '取消',
    parNowText: '因樓盤資料不完整，無法付款，須先補回填寫資料',
    thanks: '付款成功',
    payDownStar: '星級盤參考排名將於稍後更新',
    payDone: '你的樓盤已刊登',
    addGold: '增值',
    noGoldText: '請先增值或改用其他方式付款',
    noGold: '金幣不足',
    allText: '全部',
    status: '訂單狀態不正確，請重試！',
    tsp:'技術支持提供方：',
    cred:'信用卡',
    pdmeth:'付款方式',
    Remainingtime: '訂單有效期尚餘',
    close: '已關閉',
    paymentRecord: '付款記錄',
    numbering: '編號 ',
    orderDate: '訂單日期',
    currentState: '目前狀態',
    noPaymentHistory: '沒有付款記錄',
    noMoreRecords: '沒有更多記錄',
    loadingText: '加載中...',
    unPaid: '未付款',
    paid: '已付款',
    gold: '金幣',
    // pay.vue
    payTitle: '網上付款',
    paypal: 'PayPal付款',
    trans: '銀行轉賬',
    orderInfo: '訂單詳情及付款資料',
    coinNum: '金幣储值数量：',
    sum: '金額合計',
    loading: '等候付款結果',
    notOrder: '訂單號碼不存在',
    success: '支付成功',
    fail: '支付失敗',
    tip: '提示',
    confirm: '確認',
    cancel: '交易取消',
    cancelBtn: '取消',
    status: '訂單狀態不正確，請重試！',
    dealCancel: '交易失敗',
    orderPaid: '訂單已付款',
    // bankTrans
    day: '天',
    exConfirm: '立即付款',
    exTip: '您的訂單將於7天後到期，請即付款！',
    section1: '你可透過ATM轉賬、銀行櫃台或FPS轉數快入數，戶口資料如下：',
    section2: '轉賬後，請在入數紙寫上你的手提電話/訂單編號，並用以下其中一個方法通知我們：',
    t1: '帳戶名稱',
    t2: '中銀香港(代碼：012)',
    t3: '恒生銀行(代碼：024)',
    t33:"FPS轉數快系統識別碼",
    t333:'滙豐銀行 (代碼：004)',
    t4: '訂單編號',
    t5: '放盤方式',
    t6: '金額',
    t7: '訂單詳情',
    t8: '合共',
    t9: ['購買金幣', '刊登樓盤 - 標準盤', '刊登樓盤 - 星級盤'],
    t10: ['金幣', '信用卡', 'PayPal', 'AlipayHK', 'WeChat Pay HK', '銀行轉賬'],
    t11: ['尚未付款', '已付款', '已關閉'],
    t21: '傳真',
    t22: 'Whatsapp',
    t23: '電郵',
    pdCre:'信用卡',
    columns: ['paydollar','PayPal','AlipayHK','WeChat Pay HK', '銀行轉賬', 'House730金幣'],
    checked: '電郵標題請用"payment to House730" 一般情況下，我們會在下一個工作天內更新會員帳號及樓盤的相關資料。',
    section3: '如有任何問題，歡迎與我們聯絡：',
    AllTypes: '全部分類',
    PaymentMethod: '付款方式',
    OrderStatus: '訂單狀態',
    CancelOrder: '取消訂單',
    PayNow: '立即付款',
    Orders: '訂單管理',
    alipayText: '只適用於已註冊的Alipay HK用戶',
    wePayText: '只適用於已註冊的WeChat Pay HK用戶',
    cancelOrders: '是否確認要取消訂單',
    alipayTips: '頁面會直接轉換到第三方的付款頁面，需要登入 AlipayHK賬戶付款',
    wepayTips1: '頁面會轉換到第三方的付款頁面，請先儲存 QR Code，在 WeChat 打開掃瞄 QR Code功能，匯入圖片及完成付款',
    wepayTips2: ['QR Code會在', '分鐘後過期，付款完成前，請勿關閉頁面'],
    transferFake: '(會在下一個工作天內處理完成)',
    confirmPaid: '確認付款',
    orderInfo1: '訂單信息',
    Coin: 'House730金幣',
  },
  'zh-cn': {
    confirmBtn: '确认',
    cancelBtn: '取消',
    parNowText: '因楼盘资料不完整，无法付款，须先补回填写资料',
    thanks: '付款成功',
    payDownStar: '星级盘参考排名将于稍后更新',
    payDone: '你的楼盘已刊登',
    addGold: '增值',
    noGoldText: '请先增值或改用其他方式付款',
    noGold: '金币不足',
    allText: '全部',
    status: '订单状态不正确，请重试！',
    tsp:'技术支持提供方',
    cred:'信用卡',
    pdmeth:'付款方式',
    Remainingtime: '订单有效期尚余',
    close: '已关闭',
    paymentRecord: '付款记录',
    numbering: '编号 ',
    orderDate: '订单日期',
    currentState: '目前状态',
    noPaymentHistory: '沒有付款记录',
    noMoreRecords: '沒有更多记录',
    loadingText: '加载中...',
    unPaid: '未付款',
    paid: '已付款',
    gold: '金币',
    // pay.vue
    day: '天',
    payTitle: '网上付款',
    paypal: 'PayPal付款',
    trans: '银行转账',
    orderInfo: '订单详情及付款资料',
    coinNum: '金币储值数量：',
    sum: '金额合计',
    loading: '等候付款结果',
    notOrder: '订单号码不存在',
    success: '支付成功',
    fail: '支付失败',
    tip: '提示',
    status: '订单状态不正确，请重试！',
    confirm: '确认',
    cancel: '交易取消',
    cancelBtn: '取消',
    dealCancel: '交易失败',
    orderPaid: '订单已付款',
    // bankTrans
    exConfirm: '立即付款',
    exTip: '您的订单将于7天后到期，请即付款！',
    section1: '你可透过ATM转账、银行柜台或FPS转数快入数，户口资料如下：',
    section2: '转账后，请在入数纸写上你的手提电话/订单编号，并用以下其中一个方法通知我们：',
    t1: '帐户名称',
    t2: '中银香港(代码：012)',
    t3: '恒生银行(代码：024)',
    t33:'FPS转数快系統识别码',
    t333:'汇丰银行(代码：004)',
    t4: '订单编号',
    t5: '放盘方式',
    t6: '金额',
    t7: '订单详情',
    t8: '合共',
    t9: ['购买金币', '刊登楼盘 - 标准盘', '刊登楼盘 - 星级盘'],
    t10: ['金币', '信用卡', 'PayPal', 'AlipayHK', 'WeChat Pay HK', '银行转账'],
    t11: ['尚未付款', '已付款', '已关闭'],
    t21: '传真',
    t22: 'Whatsapp',
    t23: '电邮',
    columns: ['paydollar','PayPal','AlipayHK','WeChat Pay HK', '银行转账', 'House730金币'],
    pdCre:'信用卡',
    checked: '电邮标题请用"payment to House730" 一般情况下，我们会在下一个工作天内更新会员账号及楼盘的相关资料。',
    section3: '如有任何问题，欢迎与我们联络：',
    AllTypes: '全部分类',
    PaymentMethod: '付款方式',
    OrderStatus: '订单状态',
    CancelOrder: '取消订单',
    PayNow: '立即付款',
    Orders: '订单管理',
    alipayText: '只适用于已注册的Alipay HK用戶',
    wePayText: '只适用于已注册的WeChat Pay HK用戶',
    cancelOrders: '是否确认要取消订单',
    alipayTips: '页面会直接转换到第三方的付款页面，需要登入 AlipayHK账户付款',
    wepayTips1: '页面会转换到第三方的付款页面，请先储存 QR Code，在 WeChat 打开扫描 QR Code功能，汇入图片及完成付款',
    wepayTips2: ['QR Code会在', '分钟后过期，付款完成前，请勿关闭页面'],
    transferFake: '(会在下一个工作天内处理完成)',
    confirmPaid: '确认付款',
    orderInfo1: '订单信息',
    Coin: 'House730金币',
  },
  'en-us': {
    confirmBtn: 'OK',
    cancelBtn: 'Cancel',
    parNowText: 'Due to incomplete property information, payment cannot be made, and the information must be filled in first',
    thanks: 'Payment Successful',
    payDownStar: 'Premium Listing Ref. Ranking will be updated soon',
    payDone: 'Your property is now published',
    addGold: 'Recharge',
    noGoldText: 'Please recharge Gold Coin or use other payment method',
    noGold: 'Not enough Gold Coins',
    allText: 'All',
    status: 'Order status is invalid, please try again!',
    tsp:'Supported by ',
    cred:'Credit Card',
    pdmeth:'Payment Method',
    Remainingtime: 'Order valid date',
    close: 'Close',
    notOrder: 'Order No. does not exist',
    paymentRecord: 'Payment History',
    numbering: 'Order ID ',
    orderDate: 'Order Date',
    currentState: 'Status',
    noPaymentHistory: 'No Payment Record',
    noMoreRecords: 'No More Records',
    loadingText: 'loading...',
    unPaid: 'Pending',
    paid: 'Paid',
    gold: 'Gold',
    // pay.vue
    payTitle: 'Pay Online',
    paypal: 'PayPal',
    trans: 'Bank Transfer',
    orderInfo: 'Order Details and Payment Information',
    coinNum: 'The amount of gold coins stored ：',
    sum: 'Total Amount',
    loading: 'Waiting for Payment Result',
    success: 'Payment successful',
    fail: 'Payment failed',
    tip: 'prompt',
    confirm: 'OK',
    cancel: 'Order Cancelled',
    cancelBtn: 'Cancel',
    status: 'Order status is invalid, please try again!',
    dealCancel: 'Transaction Failure',
    orderPaid: 'Order already paid',
    // bankTrans
    exConfirm: 'Pay Now',
    day: 'days',
    exTip: 'Your order will be expired in 7 days, please complete payment!',
    section1: 'You can transfer funds through ATM, bank counter or FPS. The account details are as follows:',
    section2: 'After the transfer Please write your mobile no./order no. at the bank transfer slip and use one of the following methods to notify us',
    t1: 'Bank Account Name',
    t2: 'BOCHK (Bank Code: 012)',
    t3: 'Hang Seng Bank (Bank Code: 024)',
    t333:'HSBC (Bank Code:004)',
    t33:' FPS ID',
    t4: 'Order No.',
    t5: 'Listing Method',
    t6: 'Amount',
    t7: 'Order Details',
    t8: 'Total',
    t9: ['buying gold coins', 'listing properties-Standard', 'listing properties-Premium Listing'],
    t10: ['Gold Coins', 'Credit Card', 'PayPal', 'AlipayHK', 'WeChat Pay HK', 'Bank Transfer'],
    t11: ['Pending payment', 'Paid', 'Close'],
    t21: 'by fax',
    t22: 'by WhatsApp',
    t23: 'by email',
    columns: ['paydollar','PayPal','AlipayHK','WeChat Pay HK', 'Bank Transfer', 'House730 Gold Coin'],
    pdCre:'Credit Card',
    checked: 'with email subject “payment to House730”. Normally, we will update the relevant information of the member/property on or before next working day.',
    section3: 'If you have any problem, please contact us by：',
    AllTypes: 'All Types',
    PaymentMethod: 'Payment Method',
    OrderStatus: 'Order Status',
    CancelOrder: 'Cancel Order',
    PayNow: 'Pay Now',
    Orders: 'Orders',
    alipayText: 'only applicable to AlipayHK registered users',
    wePayText: 'only applicable to WeChat Pay HK registered users',
    cancelOrders: 'Are you sure to cancel the order?',
    alipayTips: 'The page will directly switch to the third-party payment page, you need to log in to AlipayHK account to pay',
    wepayTips1: 'The page will switch to the third-party payment page, please save the QR Code first, enable the scanning QR Code function in WeChat, import the picture and complete the payment.',
    wepayTips2: ['The QR Code will expire in ', ' minutes, please do not close the page until the payment is completed'],
    transferFake: '(will be handled on/before next working day)',
    confirmPaid: 'Confirm Paid',
    orderInfo1: 'Order Information',
    Coin: 'House730 Gold Coin',

  }
};
export default language[type];
